export const selectCustomersState = (state) => state.customers;
